export default {
  networks: (query) => (query ? ['networks', query] : ['networks']),
  network: (networkId) => ['networks', networkId],
  networkAccess: ({ networkId, showId }) =>
    showId ? ['networks', networkId, 'show', showId, 'access'] : ['networks', networkId, 'access'],
  networkPlans: (networkId) => ['networks', networkId, 'plans'],
};
